module.exports = __webpack_public_path__ + "static/img/powerlogo.0b217de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/powerlogo.png
// module id = 727
// module chunks = 1